export const DEFAULT_INCLUSIVITY = '[)';

export const DATE_FORMAT_URL = 'YYYYMMDD';

export const DATE_ISO_FORMAT = 'YYYY-MM-DD';

export const DATE_SHORT_FORMAT = 'D MMM';

export const DATE_SHORT_FORMAT_WITH_YEAR = 'D MMM YYYY';
export const DATE_SHORT_FORMAT_WITH_DAYOFWEEK = 'ddd D MMM';

export const DATE_LONG_FORMAT = 'D MMMM'
export const DATE_LONG_FORMAT_WITH_DAYOFWEEK = 'dddd, D MMMM'

export const DATE_LONG_FORMAT_WITH_YEAR = 'D MMMM YYYY';
export const DATE_LONG_FORMAT_WITH_YEAR_AND_DAYOFWEEK = 'dddd, D MMMM YYYY';

export const TIME_FORMAT_USER = 'H:mm';
export const TIME_FORMAT_SPAN= 'HH:mm';
